import { Icon } from '@iconify/react';
import exclamationCircleOutlined from '@iconify/icons-ant-design/exclamation-circle-outlined';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { createSearchParams } from 'react-router-dom';
// utils

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

export default function AppItemOrders({ requestsSummary }) {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        navigate({
          pathname: '/dashboard/requests',
          search: `?${createSearchParams({
            filterColumn: 'status',
            filterOperation: 'is',
            filterValue: 'OPEN'
          })}`
        });
      }}
      style={{ cursor: 'pointer' }}
    >
      <RootStyle>
        <IconWrapperStyle>
          <Icon icon={exclamationCircleOutlined} width={24} height={24} />
        </IconWrapperStyle>
        <Typography variant="h3">
          {requestsSummary.filter((req) => req.status === 'OPEN').length}
        </Typography>
        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
          Open Requests
        </Typography>
      </RootStyle>
    </div>
  );
}
